import React from "react"

const IconFinancial = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="37" fill="none" viewBox="0 0 36 37">
      <path
        fill="#726BEA"
        d="M9.474 22.074V7.579h5.684v14.495l-2.842-2.653-2.842 2.653zm9.473 2.842V0h5.685v19.232l-5.685 5.684zM0 31.453V15.158h5.684v10.61L0 31.453zm0 4.642l12.221-12.221 6.726 5.779 10.61-10.61h-3.03v-3.79H36v9.473h-3.79v-3.031L19.138 34.768 12.41 28.99l-7.106 7.106H0z"
      ></path>
    </svg>
  )
}

export default IconFinancial
